import _ from 'lodash';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { contacts } from '../../../../modules/customer/profile';
import { ui } from '../../../../modules/customer';
import classnames from 'classnames';
import ActionButton from '../../../components/ActionButton';

const ContactDetails = ({contactDetails, isVisible, close, shiftLeft, shiftRight}) => {
    let mainClasses = classnames('contact-details', { hidden: !isVisible });
    return (
        <div className={mainClasses}>
            {contactDetails &&
                <div>
                    <div className="buttons-panel">
                        <ActionButton action={shiftLeft.bind(undefined, contactDetails.id)} title="Tidligere" />
                        <ActionButton action={shiftRight.bind(undefined, contactDetails.id)} title="Neste" />
                    </div>
                    <div className="close" onClick={close.bind(undefined)} ></div>
                    <div className="contact-details-header">
                        <h3>Detaljer</h3>
                    </div>
                    <div className="contact-row">
                        <strong>Id:</strong> {contactDetails.id}
                    </div>
                    <div className="contact-row">
                        <strong>Creation date:</strong> {contactDetails.createdAt}
                    </div>
                    <div className="contact-row" id="description">
                        <strong>Comment:</strong> {contactDetails.comment || "-"}
                    </div>
                    <div className="contact-row" id="description">
                        <strong>Action Taken:</strong> {contactDetails.actionTaken || "-"}
                    </div>
                </div>
            }
        </div>
    );
}


const mapStateToProps = createStructuredSelector({
    contactDetails: contacts.selectors.getSelectedContact,
    isVisible: ui.selectors.isContactDetailsVisible
});

const mapDispatchToProps = dispatch => ({
    close: () => dispatch(contacts.actions.closeContact()),
    shiftLeft: () => dispatch(contacts.actions.shiftContactLeft()),
    shiftRight: () => dispatch(contacts.actions.shiftContactRight()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetails);